<template lang="pug">
el-form-item
  el-upload(
    :class='[baseClass, ratioClass, typeClass]',
    action='/api/v2/util/uploader',
    name='files',
    :show-file-list="false",
    :on-success='handleUploadSuccess',
    :before-upload='beforeUpload')
    template(v-if='imageUrl')
      img.thumb(:src='imageUrl')
    template(v-else)
      .func
        i.icon.el-icon-plus
    .el-upload__tip(slot="tip")
      p
        | jpg/png/gif 500kb以下 : 推奨サイズ {{ratioText['r' + ratio]}}
        br
        | ( 縦横比の異なる画像も登録可能ですが表示する際にデザインが崩れたり画像が見切れる場合などがあります )
      template(v-if='imageUrl')
        i.icon.el-icon-delete(@click='deleteImage')
</template>

<script>
export default {
  name: 'ElementUploadSingle',
  data () {
    return {
      imageUrl: null,
      baseClass: 'c-uploader',
      ratioClass: 'c-uploader__' + this.ratio,
      typeClass: 'c-uploader__' + this.type,
      ratioText: {
        r16_9: '16:9の画像',
        r1_1: 'w 960px * h 960px 以上の正方形',
        r2_1: 'w 960px * h 480px 以上',
        r3_2: 'w 1200px * h 800px 以上',
        r350_197: 'w 1400px * h 788px 以上',
        r960_531: 'w 960px * h 531px 以上',
        r960_623: 'w 960px * h 623px 以上',
        r960_680: 'w 960px * h 680px 以上',
        r960_351: 'w 960px * h 351px 以上',
        r40_17: 'w 960px * h 408px 以上',
        r960_1200: 'w 960px * h 1200px 以上',
        rnews: '縦長の表示画像は3:2の画角エリアにマージンと取ってセンターに表示されます。'
      }
    }
  },
  props: {
    form: {
      type: Object,
      required: true
    },
    /**
     * 画角を判定
     * 1_1
     * 350_197
     * 960_623
     * 960_351
     * 40_17 for caststudy
     */
    ratio: {
      type: String,
      default: '2_1'
    },
    /**
     * データ構造を判定
     * default : 画像のみ
     * thumb : thumb構造
     * nested: nested した構造
     */
    type: {
      type: String,
      default: 'default'
    },
    datakey: {
      type: String,
      required: true
    }
  },
  methods: {
    init () {
      this.setImage()
    },
    setImage () {
      let data = this.getValue()
      if (!data) return
      if (this.type === 'default') {
        this.imageUrl = data.uri
      } else if (this.type === 'thumb') {
        if (data[this.getSize()]) {
          this.imageUrl = data[this.getSize()].uri
        }
      } else if (this.type === 'nested') {
        if (data.image) {
          this.imageUrl = data.image.uri
        }
      }
    },
    handleUploadSuccess (res, file) {
      let data = this.getValue()
      const value = {
        id: res.id,
        uri: res.uri
      }
      if (this.type === 'default') {
        data.id = value.id
        data.uri = value.uri
      } else if (this.type === 'thumb') {
        data[this.getSize()] = value
      } else if (this.type === 'nested') {
        data.image = value
      }
      this.imageUrl = res.uri
    },
    /**
     * @param {Object} file
     * @returns {undefined}
     */
    beforeUpload (file) {
      const isLt500kb = file.size / 1024 / 1024 < 0.5
      if (!/^image\/[jpeg|png|gif|webp]/.test(file.type)) {
        this.$message.error('jpg/png/gifフォーマットの画像を登録してください')
        return false
      }
      if (!isLt500kb) {
        this.$message.error('500kb以下の画像ファイルを登録してください')
        return false
      }
      return true
    },
    deleteImage () {
      let data = this.getValue()
      if (this.type === 'default') {
        data.id = null
        data.uri = null
      } else if (this.type === 'thumb') {
        data[this.getSize()] = null
      } else if (this.type === 'nested') {
        data.image = null
      }
      this.imageUrl = null
    },
    getValue () {
      let data = this.form
      this.datakey.split('.').forEach((v, i) => {
        data = data[v]
      })
      return data
    },
    getSize () {
      return this.ratio === '1_1' ? 'square' : 'rectangle'
    }
  },
  watch: {
    form (newValue, oldValue) {
      this.setImage()
    }
  },
  created () {
    this.init()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Element/Upload/Single/index.vue